'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDirectionsFerry = function MdDirectionsFerry(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 10v6.6l10-3.2 10 3.2v-6.6h-20z m-3.4 21.6l-3.2-11.1q-0.5-1.5 1.1-2.1l2.1-0.7v-7.7q0-1.3 1.1-2.3t2.3-1.1h5v-5h10v5h5q1.3 0 2.3 1.1t1.1 2.3v7.7l2.1 0.7q1.6 0.6 1.1 2.1l-3.2 11.1h0q-3.9 0-6.8-3.2-2.8 3.2-6.6 3.2t-6.6-3.2q-2.9 3.2-6.8 3.2h0z m26.8 3.4h3.2v3.4h-3.2q-3.6 0-6.8-1.7-6.6 3.5-13.2 0-3.2 1.7-6.8 1.7h-3.2v-3.4h3.2q3.6 0 6.8-2.2 3 2.1 6.6 2.1t6.6-2.1q3.2 2.2 6.8 2.2z' })
        )
    );
};

exports.default = MdDirectionsFerry;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/directions-ferry.js
// module id = 1434
// module chunks = 168707334958949